module.exports = __webpack_public_path__ + "static/media/undraw_data-analysis_b7cp.bf2de992.svg";